import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import PatientMedicalHistoryAddData from './PatientMedicalHistoryAddData';

interface Props extends BaseModalProps {
	patientId: string;
	data: Record<string, string>;
}

const PatientMedicalHistoryAddDataModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.patientMedicalHistoryAddData.modalTitle'>
			<PatientMedicalHistoryAddData
				patientId={props.patientId}
				data={props.data}
			/>
		</BaseModal>
	);
};

export default PatientMedicalHistoryAddDataModal;
